import { defineColumns } from '@juvare/platform-shared/features/storage';
import { z } from 'zod';
export const shiftParticipantHoursHistoryStatus = ['addHours', 'pending', 'approved', 'deniedInaccurate', 'deniedNoShow'];
export const shiftParticipantHoursHistoryEntityName = 'shiftParticipantHoursHistory';
export const hoursStatusMap = {
    addHours: 'Add Hours',
    pending: 'Pending',
    approved: 'Approved',
    deniedInaccurate: 'Denied',
    deniedNoShow: 'No-show',
};
export const shiftParticipantHoursHistorySchema = z.object({
    participationId: z.string().uuid(),
    hoursStatus: z.enum(shiftParticipantHoursHistoryStatus),
    hours: z.number().optional(),
    hoursFrom: z.number().optional(),
    hoursTo: z.number().optional(),
    deleted: z.boolean().optional(),
    internalStatusChange: z.boolean().optional(),
    missionTypeId: z.string().uuid().optional(),
});
export const shiftParticipantHoursHistoryColumns = defineColumns({
    participationId: {
        type: 'id-required',
        index: true,
    },
    hoursStatus: {
        type: 'string-required',
        index: true,
    },
});
